import script from "./LeftNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeftNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./LeftNavigation.vue?vue&type=style&index=0&id=96e7fe68&lang=scss&scoped=true"

import exportComponent from "/Users/3t14/dev/llm-bots/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96e7fe68"]])

export default __exports__